import {CloseIcon, SearchIcon} from '@prtimes-basis/icons';
import type {ComponentProps} from 'react';
import type {ResponsiveHeader} from '..';
import {SearchScreen} from './search-screen';
import {PopularKeywords} from './popular-keywords';
import styles from './header-search-icon.module.css';

type Props = {
  readonly view: 'default' | 'search' | 'navi';
  readonly setView: (value: 'default' | 'search' | 'navi') => void;
} & Pick<ComponentProps<typeof ResponsiveHeader>, 'popularKeywords'>;

export function HeaderSearchIcon({view, setView, popularKeywords}: Props) {
  const open = () => {
    setView('search');
  };

  const close = () => {
    setView('default');
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.iconsWrapper}
        type='button'
        aria-label={view === 'search' ? '検索画面を閉じる' : '検索画面を開く'}
        onClick={view === 'search' ? close : open}
      >
        {view === 'search' ? (
          <CloseIcon
            data-testid='close-icon'
            className={styles.icon}
            variant='white'
          />
        ) : (
          <SearchIcon
            data-testid='search-icon'
            className={styles.icon}
            variant='white'
          />
        )}
      </button>

      {/* view が 'search' の時、検索画面を表示する */}
      {view === 'search' && (
        <SearchScreen
          popularKeywordsNode={
            <PopularKeywords popularKeywords={popularKeywords} />
          }
        />
      )}
    </div>
  );
}
